// ** Redux Imports
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

// ** Axios Imports
import axios, { AxiosError } from "axios";

export const getAllDepartments = createAsyncThunk(
  "departments/getAllData",
  async () => {
    let bodyContent = {
      params: {
        options: {
          query: {},
          populate: [
            {
              dir: "users",
              path: "createdBy",
              select: "username",
            },
          ],
        },
      },
    };
    const response = await axios.get("/hrm/departments", bodyContent);
    if (response.status != 200) {
      return rejectWithValue(response.data.message);
    }
    const docs = response.data?.data?.docs || [];
    return { docs, totalRows: response.data?.data?.totalDocs };
  }
);

export const getData = createAsyncThunk(
  "departments/getData",
  async (params) => {
    const response = await axios.get("/hrm/departments", {
      params: {
        options: {
          ...params,
          populate: [
            {
              dir: "users",
              path: "createdBy",
              select: "username",
            },
          ],
        },
      },
    });
    if (response.status != 200) {
      return rejectWithValue(response.data.message);
    }
    return {
      params,
      data: response.data?.data?.docs,
    };
  }
);

export const createDepartment = createAsyncThunk(
  "departments/create",
  async (
    formdata,
    { dispatch, getState, rejectWithValue, fulfillWithValue }
  ) => {
    try {
      var response = await axios.post("/hrm/departments", formdata);
      // dispatch(addDepartment(response.data?.data));
      if (response.status != 200) {
        return rejectWithValue(response.data.message);
      }
      return response.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const updateDepartment = createAsyncThunk(
  "departments/update",
  async ({ data, id }, { dispatch, getState, rejectWithValue }) => {
    try {
      var response = await axios.patch(`/hrm/departments/${id}`, data);
      // await dispatch(getData(getState().users.params));
      if (response.status != 200) {
        return rejectWithValue(response.data.message);
      }
      //  dispatch(editDepartment(response.data?.data));
      return response.data?.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const deleteDepartment = createAsyncThunk(
  "departments/delete",
  async (id, { dispatch, getState, rejectWithValue }) => {
    try {
      const response = await axios.delete(`/hrm/departments/${id}`);
      console.log(response.data);
      if (response.status != 204) {
        return rejectWithValue("Can't Delete Try Again");
      }
      await dispatch(getAllDepartments());
      return response.status;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const departmentSlice = createSlice({
  name: "departments",
  initialState: {
    data: [],
    total: 0,
    params: {},
    allData: [],
    loading: false,
    error: null,
    selectedDepartment: null,
  },
  reducers: {
    addDepartment: (state, { payload }) => {
      state.allData.push(payload);
      state.data.push(payload);
    },
    selectDepartment: (state, { payload }) => {
      state.selectedDepartment = payload;
    },
    editDepartment: (state, { payload }) => {
      state.data = state.data.map((d) => {
        if (d._id == payload._id) {
          return payload;
        }
        return d;
      });
      state.allData = state.allData.map((da) => {
        if (da._id == payload._id) {
          return payload;
        }
        return da;
      });
      state.loading = false;
      state.error = null;
      state.selectedDepartment = null;
    },
    searchFilter: (state, { payload }) => {
      if (payload == "") {
        state.data = state.allData;
        return;
      }

      state.data = state.allData.filter(
        (cs) =>
          cs.name?.toLowerCase().includes(payload.toLowerCase()) ||
          cs.phone?.toLowerCase().includes(payload.toLowerCase()) ||
          cs.email?.toLowerCase().includes(payload.toLowerCase())
      );
    },
  },

  extraReducers: (builder) => {
    builder
      .addCase(getAllDepartments.pending, (state, action) => {
        state.loading = !state.data.length ? true : false;
        state.error = null;
      })
      .addCase(getAllDepartments.fulfilled, (state, action) => {
        state.data = action.payload.docs;
        state.allData = action.payload.docs;
        state.total = action.payload.totalRows;
        state.loading = false;
        state.error = null;
      })
      .addCase(getAllDepartments.rejected, (state, { payload }) => {
        state.loading = false;
        state.error = payload;
      })
      .addCase(getData.pending, (state, action) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getData.fulfilled, (state, action) => {
        state.data = action.payload.data;
        state.params = action.payload.params;
        state.loading = false;
      })
      .addCase(getData.rejected, (state, { payload, error }) => {
        state.loading = false;
        state.error = error;
      })
      .addCase(createDepartment.pending, (state, { payload }) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(createDepartment.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.error = null;
        state.selectedDepartment = null;
        state.allData.unshift(payload.data);
        state.data.unshift(payload.data);
      })
      .addCase(createDepartment.rejected, (state, { payload, error }) => {
        state.loading = false;
        state.error = payload;
        state.selectedDepartment = null;
      })

      .addCase(updateDepartment.pending, (state, { payload }) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateDepartment.fulfilled, (state, { payload }) => {
        console.log(payload);
        state.loading = false;
        state.error = null;
        state.data = state.data.map((d) => {
          if (d._id == payload._id) {
            return payload;
          }
          return d;
        });
        state.allData = state.allData.map((da) => {
          if (da._id == payload._id) {
            return payload;
          }
          return da;
        });
        state.selectedDepartment = null;
      })
      .addCase(updateDepartment.rejected, (state, { payload, error }) => {
        state.loading = false;
        state.error = error;
      });
  },
});

export const { selectDepartment, searchFilter } = departmentSlice.actions;
export default departmentSlice.reducer;
